<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="bar"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ColumnCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    colorsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          width: '100%',
          height: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: false,
            distributed: true,
            columnWidth: '75%',
            endingShape: 'rounded',
            dataLabels: {
              position: 'top',
              enabled: true,
            },
          },
        },
        stroke: {
          show: false,
          width: 2,
          colors: ['#ddd'],
        },
        xaxis: {
          categories: ['İnallar', 'Chery', 'Citroen', 'Honda', 'Hyundai', 'Kia'],
        },
        yaxis: {
          title: {
            show: false,
            text: '',
          },
        },
        fill: {
          opacity: 1,
        },
        colors: [],
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${val}`
            },
          },
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      this.chartOptions.colors = this.colorsData
    },
  },
}
</script>
